var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { Box } from '@wix/design-system';
import { DomainActionsErrorsMap, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { InsightIntent } from '@wix/domains-serverless-interface';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { AnonymousFooter } from '../../../Components/AnonymousFooter/AnonymousFooter';
import { AnonymousVoucherBanner } from '../../../Components/VoucherBanner';
import { AnonymousBusinessEmailResultsHeader } from '../../../Components/Headers';
import { BackButton } from '../../../Components/Headers/HeaderWrapper';
import { ExperimentSpecs } from '../../../constants';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsBack } from '../../../hooks/useResultsBack';
import { useSettledMethods } from '../../../hooks/useSettledMethod';
import { ANONYMOUS_SETTLEMENTS } from '../../../utils/anonymousSettlements';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar } from '../../ResultsLayout';
import s from '../../anonymousResultsPage.scss';
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken,
  noStatus: GeneralAnonymousOverride
};
export const AnonymousBusinessEmailResultsPage = _ref => {
  let {
    handlers,
    externalViewer,
    deviceType
  } = _ref;
  useSettledMethods(ANONYMOUS_SETTLEMENTS);
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(AnonymousBusinessEmailResultsPageContent, {
    deviceType: deviceType
  })));
};
export const AnonymousBusinessEmailResultsPageContent = _ref2 => {
  var _getPremiumEssentials;
  let {
    deviceType
  } = _ref2;
  const isMobile = useIsMobile();
  const handleBackClick = useResultsBack();
  const {
    taxesNotIncluded
  } = useRecommendations({
    enableOnEmptyQuery: false
  });
  const isAnonymousCartEnabled = ((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.AnonymousCartBusinessEmail]) && !isMobile;
  const showCartHeader = Boolean(isAnonymousCartEnabled) || !isMobile;
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    biViewMode: "Storefront",
    querySubmitPath: "/",
    deviceType: deviceType,
    showCartHeader: showCartHeader,
    isResultsPageOptimizations: true,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, null),
    header: /*#__PURE__*/React.createElement(AnonymousBusinessEmailResultsHeader, {
      onBackClick: isMobile ? undefined : handleBackClick
    }),
    voucher: /*#__PURE__*/React.createElement(AnonymousVoucherBanner, {
      isResultsPageOptimizations: true
    }),
    footer: /*#__PURE__*/React.createElement(Box, {
      gridArea: "footer",
      padding: "SP6 48px",
      className: s.centeredContent,
      textAlign: "center",
      align: "center"
    }, /*#__PURE__*/React.createElement(AnonymousFooter, {
      taxesNotIncluded: taxesNotIncluded
    })),
    mobileBackButton: /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(BackButton, {
      onClick: handleBackClick
    }))
  }, /*#__PURE__*/React.createElement(ResultsRecommendations, {
    showHeroCard: true,
    className: s.centeredContent,
    insightIntent: InsightIntent.BUSINESS_EMAIL
  }));
};
//# sourceMappingURL=AnonymousBusinessEmailResultsPage.js.map